// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"1bc13653","58":"0a3aa5c1","413":"cb2198a2","444":"522a53b6","588":"cd1606b1","963":"8c82d790"}[chunkId] + ".chunk.js";
};